import { IssueStatusType } from '@kcftech/prometheustypescriptapiclient';
import { StatusLozenge } from 'pages/Desk/issues/StatusLozenge';
import { useMemo } from 'react';
import { MultiSelectQuickFilterButton } from 'shared/filter_pane/MultiSelectQuickFilterButton';
import { sortBy } from 'utils/array';

const customerVisibleStatusTypes = Object.values(IssueStatusType).filter(
    // Currently, removed issues are only meant to be consumed by admin/sentry
    // users / for reporting purposes in regards to model training and should
    // not be displayed in the UI
    (s) => s !== IssueStatusType.Removed
);

export type StatusFilterButtonProps = {
    statuses: IssueStatusType[];
    onChangeStatuses: (statuses: IssueStatusType[]) => void;
};

export function StatusFilterButton({
    statuses,
    onChangeStatuses,
}: StatusFilterButtonProps) {
    const options = useMemo(
        () =>
            sortBy(customerVisibleStatusTypes, (s) => s).map((status) => ({
                value: status,
                label: <StatusLozenge status={status} />,
            })),
        []
    );

    return (
        <MultiSelectQuickFilterButton
            id="status-filter"
            label="Status"
            selectedValues={statuses}
            onChangeValues={onChangeStatuses}
            options={options}
        />
    );
}
